import { render, staticRenderFns } from "./StarRatingMod.vue?vue&type=template&id=ac0b4c5a"
import script from "./StarRatingMod.vue?vue&type=script&lang=js"
export * from "./StarRatingMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports